import { SWATCHES } from '../lib/colors';

interface Props {
  value: string | null;
  onChange: (key: string | null) => void;
}

/** The palette, plus "no colour" — which stays the default. */
export function ColorSwatches({ value, onChange }: Props) {
  return (
    <div className="swatches" role="radiogroup" aria-label="Colour">
      <button
        type="button"
        className={`swatch swatch--none${value === null ? ' is-active' : ''}`}
        title="No colour"
        aria-label="No colour"
        aria-checked={value === null}
        role="radio"
        onClick={() => onChange(null)}
      />
      {SWATCHES.map((swatch) => (
        <button
          key={swatch.key}
          type="button"
          className={`swatch${value === swatch.key ? ' is-active' : ''}`}
          style={{ background: swatch.hex }}
          title={swatch.label}
          aria-label={swatch.label}
          aria-checked={value === swatch.key}
          role="radio"
          onClick={() => onChange(swatch.key)}
        />
      ))}
    </div>
  );
}
